import Vue from "vue";
import App from "./layouts/App.vue";
import router from "./router";
import store from "./store";
import Notifications from "vue-notification";
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "quill-mention";
import VueSocketIO from "vue-socket.io";
import { URL } from "./axios";
import vmodal from "vue-js-modal";
Vue.use(vmodal);

const token = window.localStorage.getItem("SAtoken");
const socketOptions = {
  jsonp: false,
  reconnection: false,
  reconnectionDelay: 100,
  reconnectionAttempts: 3,
  transports: ["websocket"],
  timeout: 10000,
  query: {
    Authorization: token,
  },
};

Vue.use(
  new VueSocketIO({
    debug: true,
    connection: URL,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
    options: socketOptions,
  })
);

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

import panelCapabilitiesMixin from "./mixins/panelCapabilities.mixin";
Vue.mixin(panelCapabilitiesMixin);

Vue.use(Notifications);
Vue.use(VueQuillEditor, {
  placeholder: "Dodaj treść...",
  modules: {
    toolbar: {
      container: [
        [{ size: ["small", false, "large", "huge"] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["emoji"],
        [{ align: [] }],
        ["link"],
      ],
    },
  },
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
